import { useEffect } from 'react';
import { dragContainsFiles } from '@/utils/dragSupport.util';

// Site-wide safety net: when a file is dropped anywhere *outside* an explicit
// drop zone, the browser would otherwise navigate to / open that file and blow
// away the SPA. We block the default for file drags only — text drags (e.g.
// into an input) and non-file drag interactions are left untouched. Real drop
// zones still work: their element handlers run first while the event bubbles,
// and this window-level listener only ever calls preventDefault (never
// stopPropagation), so it acts purely as a fallback.
const usePreventFileDropNavigation = (): void => {
  useEffect(() => {
    const preventFileDefault = (event: DragEvent) => {
      if (dragContainsFiles(event.dataTransfer)) {
        event.preventDefault();
      }
    };

    window.addEventListener('dragover', preventFileDefault);
    window.addEventListener('drop', preventFileDefault);
    return () => {
      window.removeEventListener('dragover', preventFileDefault);
      window.removeEventListener('drop', preventFileDefault);
    };
  }, []);
};

export default usePreventFileDropNavigation;
